import { createFeedbackRequest } from './adapters';
import { ISaveFeedbackRequest } from '../common/types';
import { PYTHON_BACKEND } from '../constants/env';
import { ApiEndpoint, ContentType, HttpHeader, HttpMethod, HttpStatus } from '../constants/http';

export async function saveFeedback({
  queryId,
  questionId,
  value,
}: ISaveFeedbackRequest): Promise<void> {
  const baseUrl = PYTHON_BACKEND;
  const endpoint = ApiEndpoint.Feedback;
  const url = `${baseUrl}/${endpoint}/`;
  const requestOptions = {
    method: HttpMethod.POST,
    headers: {
      [HttpHeader.ContentType]: ContentType.JSON,
    },
    body: JSON.stringify(createFeedbackRequest({ queryId, questionId, value })),
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (!response.ok) {
      if (response.status === HttpStatus.InternalServerError) {
        throw new Error('[api.save-feedback]: Internal Server Error');
      }
      if (data && data.message) {
        throw new Error(data.message);
      }
      throw new Error('[api.save-feedback]: Something went wrong!');
    }
    return data;
  } catch (error: unknown) {
    console.error(error);
  }
}
